import { Link } from "react-router-dom";
import { Phone, MapPin, Clock, Facebook } from "lucide-react";
import { RESTAURANT } from "../data/restaurant";
import Logo from "./Logo";
import OpenNowBadge from "./OpenNowBadge";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0E0E1A] text-[#E7E5E4] mt-20 relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <Logo className="h-16 md:h-20 w-auto" />
            <p className="mt-6 text-[#A8A29E] max-w-md leading-relaxed">
              A bold fusion of authentic Indian cuisine and modern pizza craft —
              served warm, fast, and full of flavor in the heart of Lethbridge.
            </p>
            <a
              href={RESTAURANT.facebook}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook"
              className="inline-flex items-center gap-2 mt-6 text-sm text-[#E7E5E4] hover:text-[#E5B07D] transition-colors"
            >
              <Facebook className="w-4 h-4" /> facebook.com/rivaazpizza
            </a>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs tracking-[0.25em] uppercase text-[#E5B07D] font-bold mb-4">
              Visit
            </div>
            <div className="flex items-start gap-3 text-sm text-[#D6D3D1] mb-3">
              <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
              <span>{RESTAURANT.address}</span>
            </div>
            <a
              href={`tel:${RESTAURANT.phoneRaw}`}
              data-testid="footer-phone"
              className="flex items-center gap-3 text-sm text-[#D6D3D1] hover:text-[#E5B07D] transition-colors mb-3"
            >
              <Phone className="w-4 h-4" /> {RESTAURANT.phone}
            </a>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs tracking-[0.25em] uppercase text-[#E5B07D] font-bold mb-4">
              Explore
            </div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/menu" data-testid="footer-link-menu" className="text-[#D6D3D1] hover:text-[#E5B07D]">Menu</Link></li>
              <li><Link to="/about" data-testid="footer-link-about" className="text-[#D6D3D1] hover:text-[#E5B07D]">Our Story</Link></li>
              <li><Link to="/contact" data-testid="footer-link-contact" className="text-[#D6D3D1] hover:text-[#E5B07D]">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs tracking-[0.25em] uppercase text-[#E5B07D] font-bold mb-4 flex items-center gap-2">
              <Clock className="w-3 h-3" /> Hours
            </div>
            <OpenNowBadge variant="inline" className="mb-3" />
            <ul className="space-y-1.5 text-sm text-[#D6D3D1]">
              {RESTAURANT.hoursShort.map((h, i) => (
                <li key={i}>{h}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#A8A29E]">
          <div>© {new Date().getFullYear()} Rivaaz Indian Pizza & Cuisine · <a href="https://rivaaz.ca" className="hover:text-[#C9853E] transition-colors">rivaaz.ca</a> · Crafted in Lethbridge.</div>
          <div>Indian Pizza Lethbridge · Best Indian Food Lethbridge · Fusion Pizza Alberta</div>
        </div>
      </div>
    </footer>
  );
}
